'use strict';

const SELECTORS = {
    fields: '.cc-form__input, .cc-form__textarea'
};

const CLASSES = {
    labelFocused: 'cc-form__label--focused'
};

/**
 * Keeps a field's floating label in sync with its current value.
 * The label normally floats via the CSS :placeholder-shown trick, but Android app
 * webviews can render fields with a pre-filled value without the pseudo-class being
 * applied, leaving the label overlapping the value. This mirrors that same state
 * with a plain class instead, which the CSS already supports (see .cc-form__label--focused).
 * @param {HTMLElement} field - input or textarea element
 * @returns {void}
 */
function syncLabel(field) {
    const $field = $(field);
    const $label = $field.siblings('.cc-form__label');

    if (!$label.length) {
        return;
    }

    $label.toggleClass(CLASSES.labelFocused, $field.val().trim() !== '');
}

module.exports = () => {
    // Deferred so it doesn't compete with the initial paint.
    setTimeout(() => {
        $(SELECTORS.fields).each((index, field) => {
            syncLabel(field);
        });
    }, 0);

    $('body').on('input change blur', SELECTORS.fields, function () {
        syncLabel(this);
    });
};
